import type { SVGProps } from "react";

export const LinkTo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 4v5a1 1 0 0 1-2 0V6.414l-7.293 7.293A.998.998 0 0 1 10 13a1 1 0 0 1 .293-.707L17.586 5H15a1 1 0 1 1 0-2h5a.996.996 0 0 1 1 1Zm-1 8a1 1 0 0 0-1 1v4c0 1.439-.561 2-2 2H7c-1.439 0-2-.561-2-2V7c0-1.439.561-2 2-2h4a1 1 0 1 0 0-2H7C4.458 3 3 4.458 3 7v10c0 2.542 1.458 4 4 4h10c2.542 0 4-1.458 4-4v-4a1 1 0 0 0-1-1Z"
    />
  </svg>
);
